// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"29f9088852b2d6c73099","293":"0087ebaa84d9c5a04dab"}[chunkId] + ".js";
};